import { Component, OnInit } from '@angular/core';
import {ApiService} from '@core/services/api/api.service';
import { ItemPredicate } from '@datorama/akita';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-max-mortgage',
  templateUrl: './max-mortgage.component.html',
  styleUrls: ['./max-mortgage.component.scss'],
})
export class MaxMortgageComponent implements OnInit {
  private subs = new Subscription();

  constructor(
    public api: ApiService,
  ) { }

  title = "Maximale hypotheek check";
  desc = "Druk hier voor een gratis maximaal hypotheek check!";

  page = 0;
  maxPage = 6;
  maritalStatus = 0;
  marriedBefore = "false";
  salary = 0;
  thirteenthMonth = false;
  holidayPay = false;
  partnerAlimonyReceive = 0;
  partnerAlimony = 0;
  personalLoan = 0;
  studentDebt = 0;
  studentDebtType = "";
  marketValue = 0;
  duration = 30;
  interest = 5;
  energyEfficientHome = "0";
  energySavingFacilities = 0;

  costOfLivingItems = [];

  personalLoanPercentage = 2;
  studentDebtOldPercentage = 0.75;
  studentDebtNewPercentage = 0.45;
  studentDebtPercentage = 0.00;

  energySavings = {
    energyLabel: 9000,
    zeroEnergy: 15000,
    zeroEnergyGuarantee: 25000
  };
  

  ngOnInit() {

  }

  previousPage(pageIndex) {

    if (this.page == 4 && this.marriedBefore == "false") {      
      this.page = pageIndex - 2;
      console.log("=========================================");
      console.log("Skipping partnerAlimony");
      console.log("===============  " + this.page + "/" + this.maxPage + "  =======================");
      console.log("maritalStatus: " + this.maritalStatus);
      console.log("marriedBefore: " + this.marriedBefore);
      console.log("salary: " + this.salary);
      console.log("thirteenthMonth: " + this.thirteenthMonth);
      console.log("holidayPay: " + this.holidayPay);
      console.log("partnerAlimonyReceive: " + this.partnerAlimonyReceive);
      console.log("partnerAlimony: " + this.partnerAlimony);
      console.log("personalLoan: " + this.personalLoan);
      console.log("studentDebt: " + this.studentDebt);
      console.log("studentDebtType: " + this.studentDebtType);
      console.log("marketValue: " + this.marketValue);
      console.log("duration: " + this.duration);
      console.log("interest: " + this.interest);
      console.log("energyEfficientHome: " + this.energyEfficientHome);
      console.log("energySavingFacilities: " + this.energySavingFacilities);
    }
    else {
      this.page = pageIndex - 1;
      console.log("===============  " + this.page + "/" + this.maxPage + "  =======================");
      console.log("maritalStatus: " + this.maritalStatus);
      console.log("marriedBefore: " + this.marriedBefore);
      console.log("salary: " + this.salary);
      console.log("thirteenthMonth: " + this.thirteenthMonth);
      console.log("holidayPay: " + this.holidayPay);
      console.log("partnerAlimonyReceive: " + this.partnerAlimonyReceive);
      console.log("partnerAlimony: " + this.partnerAlimony);
      console.log("personalLoan: " + this.personalLoan);
      console.log("studentDebt: " + this.studentDebt);
      console.log("studentDebtType: " + this.studentDebtType);
      console.log("marketValue: " + this.marketValue);
      console.log("duration: " + this.duration);
      console.log("interest: " + this.interest);
      console.log("energyEfficientHome: " + this.energyEfficientHome);
      console.log("energySavingFacilities: " + this.energySavingFacilities);
      console.log("costOfLivingItems: " + this.costOfLivingItems);
      
    }

  }

  nextpage(pageIndex) {

    if (this.page == 2 && this.marriedBefore == "false") {      
      this.page = pageIndex + 2;
      console.log("=========================================");
      console.log("Skipping partnerAlimony");
      console.log("===============  " + this.page + "/" + this.maxPage + "  =======================");
      console.log("maritalStatus: " + this.maritalStatus);
      console.log("marriedBefore: " + this.marriedBefore);
      console.log("salary: " + this.salary);
      console.log("thirteenthMonth: " + this.thirteenthMonth);
      console.log("holidayPay: " + this.holidayPay);
      console.log("partnerAlimonyReceive: " + this.partnerAlimonyReceive);
      console.log("partnerAlimony: " + this.partnerAlimony);
      console.log("personalLoan: " + this.personalLoan);
      console.log("studentDebt: " + this.studentDebt);
      console.log("studentDebtType: " + this.studentDebtType);
      console.log("marketValue: " + this.marketValue);
      console.log("duration: " + this.duration);
      console.log("interest: " + this.interest);
      console.log("energyEfficientHome: " + this.energyEfficientHome);
      console.log("energySavingFacilities: " + this.energySavingFacilities);
    }
    else {
      this.page = pageIndex + 1;
      console.log("===============  " + this.page + "/" + this.maxPage + "  =======================");
      console.log("maritalStatus: " + this.maritalStatus);
      console.log("marriedBefore: " + this.marriedBefore);
      console.log("salary: " + this.salary);
      console.log("thirteenthMonth: " + this.thirteenthMonth);
      console.log("holidayPay: " + this.holidayPay);
      console.log("partnerAlimonyReceive: " + this.partnerAlimonyReceive);
      console.log("partnerAlimony: " + this.partnerAlimony);
      console.log("personalLoan: " + this.personalLoan);
      console.log("studentDebt: " + this.studentDebt);
      console.log("studentDebtType: " + this.studentDebtType);
      console.log("marketValue: " + this.marketValue);
      console.log("duration: " + this.duration);
      console.log("interest: " + this.interest);
      console.log("energyEfficientHome: " + this.energyEfficientHome);
      console.log("energySavingFacilities: " + this.energySavingFacilities);
      console.log("costOfLivingItems: " + this.costOfLivingItems);
      
    }
  }
  durationChecker() {
    if (this.duration < 10) {
      this.interest = 5;
    }
  }

  fetchCostOfLiving() {
    let data = {
      type: 'DEFAULT',
      interest: this.interest
    };

    this.subs.add(
      this.api.post('calculation/cost-of-living-percentages', data).subscribe(response => {
        this.costOfLivingItems = response;})
    );
  }
  
  thirteenthMonthAmount() {
    if (this.thirteenthMonth === false) {
      return 0;
    }

    return this.salary / 12;
  }

  holidayAmount() {
    if (this.holidayPay === false) {
      return 0;
    }

    return (this.thirteenthMonthAmount() + this.salary) * 0.08;
  }

  income() {
    return this.thirteenthMonthAmount() + this.holidayAmount() + this.salary + this.partnerAlimonyReceive;
  }

  formatNumber(value) {
    let number = parseFloat(value);
    let options = { minimumFractionDigits: 2, style: 'currency', currency: 'EUR' };
    return number.toLocaleString("nl-NL", options);
  }

  personalLoanAmount() {
    if (this.personalLoan == 0) {
      return 0;
    }

    return this.personalLoan * (this.personalLoanPercentage / 100);
  }

  studentDebtTypeCheck() {

    if (this.studentDebtType == "old") {
      this.studentDebtPercentage = this.studentDebtOldPercentage;
    }
    else if (this.studentDebtType == "new") {
      this.studentDebtPercentage = this.studentDebtNewPercentage;
    }

  }
  studentDebtAmount() {
    if (this.studentDebt == 0) {
      return 0;
    }

    return this.studentDebt * (this.studentDebtPercentage / 100);
  }

  expenses() {
    return this.partnerAlimony;
  }

  energyBenefit() {
    if (this.energyEfficientHome === "0") {
      return 0;
    }

    if (this.energySavings[this.energyEfficientHome] <= this.energySavingFacilities) {
      return this.energySavings[this.energyEfficientHome];
    }

    return this.energySavingFacilities;
  }

  grossIncome() {
    return this.income() - this.expenses();
  }

  maxLivingCostPerMonth() {
    if (! this.grossIncome()) {
      return 0;
    }

    return (this.grossIncome() * (this.costOfLivingPercentage() / 100) / 12) - this.expensesPerMonth();
  }

  costOfLivingPercentage() {
    if (this.costOfLivingItems.length <= 0) {
      return 0;
    }

    let found = this.costOfLivingItems.find(item => {
      return item.income <= this.grossIncome();
    });

    return found.standard * 100;
  }

  expensesPerMonth() {
    return this.personalLoanAmount() + this.studentDebtAmount();
  }

  maxMortgageIncome() {
    if (! this.maxLivingCostPerMonth() && ! this.mortgageInterest()) {
      return 0;
    }

    return this.maxLivingCostPerMonth() / this.mortgageInterest();
  }

  mortgageInterest() {
    let monthInterest = (this.interest / 100) / 12;

    return monthInterest * Math.pow((monthInterest + 1), this.durationInMonths()) / (Math.pow((monthInterest + 1), this.durationInMonths()) - 1);
  }

  durationInMonths() {
    return this.duration * 12;
  }

  maxMortgage() {
    if (! this.maxMortgageIncome()) {
      return 0;
    }

    // Max 106% including energy benefit
    let max = this.maxMortgageIncome() + this.energyBenefit();
    if (this.marketValue && max > this.marketValue * 1.06) {
      return this.marketValue * 1.06;
    }

    // Max 100% of market value
    if (this.marketValue && this.maxMortgageIncome() > this.marketValue) {
      return this.marketValue;
    }

    return max;
  }

  goToFinopsSite() {
    window.open('https://finopshypotheken.nl/afspraak-maken/', '_blank');
    window.open('https://mijn.belastingdienst.nl/VIADownload2021/index.html', '_blank');
  }
}
